export const generateSquareStyles = ({ colors = {}, dimensions = {}, textAlign = 'left', buttonAlign = 'left', fontSpacing = {
    letterSpacing: { value: 0, unit: 'px' },
    lineHeight: { value: 1.5, unit: 'em' },
    wordSpacing: { value: 0, unit: 'px' }
} }) => `
.radio-player.square {
    position: relative;
    aspect-ratio: 1;
    height: ${dimensions?.width || '300px'};
    padding: ${dimensions?.padding || '15px'};
    margin: ${dimensions?.margin || '10px'};
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.radio-player.square .album-artwork {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: ${dimensions?.borderRadius || '8px'};
    z-index: 1;
}

.radio-player.square .album-artwork img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
}

.radio-player.square .artwork-overlay {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.7) 100%);
    z-index: 2;
}

.radio-player.square .player-content {
    position: relative;
    z-index: 3;
    padding: 10px 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: 100%;
}

.radio-player.square .station-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 5px;
}

.radio-player.square .radio-name {
    font-size: ${({ fontSize }) => `${fontSize.value}${fontSize.unit}` || '1rem'};
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.square .live-container {
    display: flex;
    align-items: center;
    gap: 5px;
    background: rgba(0, 0, 0, 0.3);
    padding: 4px 8px;
    border-radius: 12px;
    backdrop-filter: blur(4px);
}

.radio-player.square .live-text {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.square .song-info {
    padding: 0;
    margin-bottom: 20px;
    text-align: ${textAlign};
    margin-top: auto;
}

.radio-player.square .song-name {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    font-size: 16px;
    margin-bottom: 4px;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.square .artist-name {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    font-size: 14px;
    opacity: 0.8;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.square .controls-container {
    width: 100%;
    margin-bottom: 30px;
}

.radio-player.square .controls {
    display: flex;
    align-items: center;
    justify-content: ${buttonAlign};
    gap: 30px;
    padding: 0;
}

.radio-player.square .control-button {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.radio-player.square .control-button.play-button {
    font-size: 1.5rem;
}

.radio-player.square .time-bar-container {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0;
    width: 100%;
    z-index: 3;
}

.radio-player.square .time-bar {
    border-radius: 0;
}

.radio-player.square .time-bar-progress {
    border-radius: 0;
}

.radio-player.square .time-info {
    position: absolute;
    bottom: 4px;
    left: 0;
    width: 100%;
    padding: 0 10px;
    z-index: 4;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    color: ${colors?.text || 'white'} !important;
}

.radio-player.square .volume-bar-container {
    bottom: 100%;
    right: 0;
    transform: translate(170%, 0px);
    background: ${colors?.background || 'rgba(0, 0, 0, 0.9)'};
    padding: 12px 8px;
    border-radius: ${dimensions?.borderRadius || '12px'};
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 10000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: default;
    height: 100px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}
`; 